export const color = {
  primary: {
    100: '#e5f2f9',
    200: '#cce6f3',
    300: '#99cce8',
    400: '#66b3dc',
    500: '#3399d1',
    600: '#0080c5',
    700: '#00669e',
    800: '#004d76',
    900: '#00334f',
  },

  secondary: {
    100: '#e9e9eb',
    200: '#d3d4d8',
    300: '#a8a9b0',
    400: '#7c7d89',
    500: '#515261',
    600: '#25273a',
    700: '#1e1f2e',
    800: '#161723',
    900: '#0f1017',
  },

  tertiary: {
    100: '#e9f5ed',
    200: '#d2ebda',
    300: '#a6d7b6',
    400: '#79c291',
    500: '#4dae6d',
    600: '#209a48',
    700: '#1a7b3a',
    800: '#135c2b',
    900: '#0d3e1d',
  },

  neutral: {
    50: '#FCFCFB',
    100: '#fafaf9',
    200: '#f5f5f4',
    300: '#e7e5e4',
    400: '#d6d3d1',
    500: '#a8a29e',
    600: '#78716c',
    700: '#57534e',
    800: '#292524',
    900: '#1c1917',
    black: '#000000',
    white: '#ffffff',
    black50: 'rgba(0, 0, 0, 0.5)',
    white50: 'rgba(255, 255, 255, 0.5)',
  },

  error: {
    50: '#fcf3f5',
    100: '#f9e7ea',
    200: '#f4cfd5',
    300: '#e99fab',
    400: '#de7082',
    500: '#d34058',
    600: '#c8102e',
    700: '#a00d25',
    800: '#780a1c',
    900: '#500612',
  },

  warning: {
    50: '#fef8f4',
    100: '#fff4e5',
    200: '#fbe2cc',
    300: '#f8c49a',
    400: '#f4a767',
    500: '#f18935',
    600: '#f47421',
    700: '#a64c01',
    800: '#8e4101',
    900: '#5f2b01',
  },

  info: {
    50: '#f2f9fc',
    100: '#e5f2f9',
    200: '#cce6f3',
    300: '#99cce8',
    400: '#66b3dc',
    500: '#3399d1',
    600: '#0080c5',
    700: '#00669e',
    800: '#004d76',
    900: '#00334f',
  },

  success: {
    50: '#f5fbf4',
    100: '#ecf7e9',
    200: '#d8efd3',
    300: '#b2dfa8',
    400: '#8bce7c',
    500: '#65be51',
    600: '#209a48',
    700: '#328b1e',
    800: '#256816',
    900: '#19460f',
  },

  yellow: {
    50: '#fefbf2',
    100: '#fef7e5',
    200: '#fdf0cc',
    300: '#fbe199',
    400: '#f8d166',
    500: '#f6c233',
    600: '#f4b300',
    700: '#c38f00',
    800: '#926b00',
    900: '#624800',
  },

  darkGreen: {
    100: '#e8f1eb',
    200: '#d1e3d8',
    300: '#a2c7b1',
    400: '#74aa89',
    500: '#458e62',
    600: '#17723b',
    700: '#125b2f',
    800: '#0e4423',
    900: '#092e18',
  },

  teal: {
    100: '#e9f3f4',
    200: '#d4e7ea',
    300: '#a8d0d5',
    400: '#7db8bf',
    500: '#51a1aa',
    600: '#268995',
    700: '#1e6e77',
    800: '#175259',
    900: '#0f373c',
  },
};

export default color;